import React from "react";
import { useState, useEffect } from "react";
import { Form, Button, Col, Row, Container, Modal } from "react-bootstrap";
import {
  utilGetInventario,
  utilUpdatePlatilloMenu,
  utilGetCollectionFilterReference,
  utilCreateInventario,
} from "../util/UtilsFirebase";
import { Rows } from "../pages/trucks/menu/modal/Rows";
import { useAuthContext } from "../hooks/useAuthContext";
import "./RecetaModal.css";
const RecetaModal = ({
  menu,
  showReceta,
  mod,
  itemPlatillo,
  handleCloseReceta,
}) => {
  const [initialRecetaState] = useState({
    img: null,
    name: "",
    active: true,
    description: "",
    ncosto1: "",
    costo1: "",
    ncosto2: "",
    costo2: "",
    ncosto3: "",
    costo3: "",
    show: true,
    available: true,
  });
  const [ingredientenuevo] = useState({
    ingrediente: null,
    cantidad: 0,
  });
  const { register } = useAuthContext();
  const [Receta, setReceta] = useState(initialRecetaState);
  const [isDelete, setIsDelete] = useState(false);
  const [categoriaSelected, setcategoriaSelected] = useState(null);
  const [productos, setProductos] = useState([]);
  const [rowsI, setRowsI] = useState([ingredientenuevo]);

  const handleCloseLocal = async () => {
    //setReceta(null);
    setcategoriaSelected(0);
    setRowsI([ingredientenuevo]);
    handleCloseReceta();
  };

  const saveReceta = async () => {
    if (mod === "ADD") {
      const btn = document.getElementById("BtnGuardar");
      btn.disabled = true;
      let ingredienteIncompleto = false;

      rowsI.forEach((element) => {
        if (element.ingrediente == null) {
          alert("Seleccione todos los ingredientes");
          btn.disabled = false;
          ingredienteIncompleto = true;
        }
        if (element.cantidad === 0) {
          alert("Coloque una cantidad para todos los ingredientes");
          btn.disabled = false;
          ingredienteIncompleto = true;
        }
      });
      if (ingredienteIncompleto) {
        return;
      }
      Receta.receta = rowsI;

      utilUpdatePlatilloMenu(menu.id, categoriaSelected, Receta);
      setRowsI([ingredientenuevo]);
      handleCloseReceta();
    }

    if (mod === "UPD") {
      let ingredienteIncompleto = false;

      rowsI.forEach((element) => {
        if (element.ingrediente == null || element.ingrediente === "") {
          alert("Seleccione todos los ingredientes");
          ingredienteIncompleto = true;
        }
        if (element.cantidad === 0) {
          alert("Coloque una cantidad para todos los ingredientes");
          ingredienteIncompleto = true;
        }
      });
      if (ingredienteIncompleto) {
        return;
      }

      Receta.receta = rowsI;

      utilUpdatePlatilloMenu(menu.id, categoriaSelected, Receta);
      //setReceta(null);
      setRowsI([ingredientenuevo]);
      handleCloseReceta();
    }
  };

  const handleOnChange = (index, name, value) => {
    const copyRows = [...rowsI];
    copyRows[index] = {
      ...copyRows[index],
      [name]: value,
    };
    setRowsI(copyRows);
  };

  const handleOnAdd = () => {
    rowsI.forEach((element) => {
      if (element.ingrediente) {
      }
    });
    if (rowsI.length < productos.length) {
      setRowsI(rowsI.concat(ingredientenuevo));
    } else {
      alert("No cuentas con mas ingredientes");
    }
  };

  const handleOnRemove = (index) => {
    const copyRows = [...rowsI];
    copyRows.splice(index, 1);
    setRowsI(copyRows);
  };

  useEffect(() => {
    async function getInventario() {
      const fetchOrders = await utilGetCollectionFilterReference(
        "inventario",
        "registro",
        "==",
        register.id,
        "registro"
      );
      if (fetchOrders.length !== 0) {
        const invent = await utilGetInventario(fetchOrders[0].id);
        setProductos(invent.productos);
      } else {
        const invent = {
          registro: null,
        };
        const inventarioid = await utilCreateInventario(invent, register.id);
        const inventa = await utilGetInventario(inventarioid);
        setProductos(inventa.productos);
      }
    }
    async function getReceta() {
      const fetchOrders = await utilGetCollectionFilterReference(
        "inventario",
        "registro",
        "==",
        register.id,
        "registro"
      );
      if (fetchOrders.length !== 0) {
        const invent = await utilGetInventario(fetchOrders[0].id);
        setProductos(invent.productos);
      } else {
        const invent = {
          registro: null,
        };
        const inventarioid = await utilCreateInventario(invent, register.id);
        const inventa = await utilGetInventario(inventarioid);
        setProductos(inventa.productos);
      }
    }
    if (showReceta) {
      console.log("EntroReceta");

      if (mod) {
        getInventario();
        getReceta();
        if (itemPlatillo) {
          setReceta(itemPlatillo);
          if (itemPlatillo.receta != null) {
            setRowsI(itemPlatillo.receta);
          } else {
            setRowsI([ingredientenuevo]);
          }

          if (mod === "UPD") {
            setcategoriaSelected(itemPlatillo.categoria.id);
          }

          if (mod === "ADD") {
            setReceta(initialRecetaState);
            setcategoriaSelected(0);
          }

          if (mod === "DLT") {
            setIsDelete(true);
            setcategoriaSelected(itemPlatillo.categoria.id);
          } else {
            setIsDelete(false);
          }
        } else {
          setReceta(initialRecetaState);
          setRowsI([ingredientenuevo]);
        }
      }
    }
  }, [
    showReceta,
    itemPlatillo,
    mod,
    menu,
    register.id,
    ingredientenuevo,
    initialRecetaState,
  ]);

  return (
    <Modal show={showReceta} onHide={handleCloseReceta} size="lg">
      <Modal.Header closeButton>
        <Modal.Title> Receta </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col>
              <Form>
                <div id="Ingredientes">
                  <Row>
                    {rowsI.map((row, index) => (
                      <Rows
                        {...row}
                        onChange={(name, value) =>
                          handleOnChange(index, name, value)
                        }
                        onRemove={() => handleOnRemove(index)}
                        key={index}
                        productos={productos}
                        isDelete={isDelete}
                        cantidad={row.cantidad}
                        ingrediente={row.ingrediente}
                        mod={mod}
                      />
                    ))}
                  </Row>
                  <br />
                  {mod !== "DLT" ? (
                    <Button onClick={handleOnAdd}>Agregar</Button>
                  ) : (
                    ""
                  )}
                </div>
                <br />
              </Form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseLocal}>
          CANCELAR
        </Button>
        <Button
          id="BtnGuardar"
          variant={mod && mod === "DLT" ? "danger" : "primary"}
          onClick={saveReceta}
        >
          {mod && mod === "DLT" ? "ELIMINAR" : "GUARDAR"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RecetaModal;
